import { Injectable } from "@angular/core";
import { NewsItem } from "@ha/data/basic";
import { Action, State, StateContext } from "@ngxs/store";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { Home } from "./../models/home.model";
import { HomeService } from "./../services/home.service";
import { HomeActions } from "./home.actions";

export interface HomeStateModel {
    data: Home;
    newsItems: NewsItem[];
}

@Injectable()
@State<HomeStateModel>({
    name: "home",
})
export class HomeState {
    constructor(private homeService: HomeService) {}

    @Action(HomeActions.Load)
    public load(ctx: StateContext<HomeStateModel>): Observable<Home> {
        return this.homeService.data().pipe(tap((data) => {
            ctx.patchState({
                data: data,
            });
        }));
    }

    @Action(HomeActions.Load)
    public loadNews(ctx: StateContext<HomeStateModel>): Observable<NewsItem[]> {
        return this.homeService.getNews().pipe(tap((data) => {
            ctx.patchState({
                newsItems: data,
            });
        }));
    }
}
